<template>
  <v-dialog
      v-model="dialog"
      scrollable
      max-width="50%"
  >
    <v-card>
      <v-card-text style="min-height: 500px;">
        <v-container class="pb-0 mb-0">
          <v-row>
            <v-col cols="6" class="greeting">
              <h3>{{ $t('patch:greeting', {name: user.name}) }}</h3>
            </v-col>
            <v-col cols="6" class="text-center">
              <v-icon
                  color="primary"
                  class="patch-core-icon"
              >drafts
              </v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">

            </v-col>
          </v-row>
        </v-container>
        <v-container class="pt-0 mt-0">
          <v-row v-for="patch in patchList" :key="patch">
            <v-col class="ml-0 pl-0 pt-0 mt-0">
              <v-container>
                <v-row>
                  <v-col>
                    <h3 class="mb-0" v-html="$t('patch:patch-text.' + patch + '.title')"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-html="$t('patch:patch-text.' + patch + '.text')"/>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
        >
          {{ $t("buttons:close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import UsersService from '@/modules/core/services/users-service';
import DataUtils from '@/modules/core/services/data-utils';
import Users from '@/modules/core/data/users';

export default {
  name: 'PatchPopupWindow',
  components: {},
  data() {
    return {
      patchList: [],
      dialog: false,
      checkInterval: {},
      user: {}
    }
  },
  watch: {
    patchList() {
      this.dialog = this.patchList.length > 0;
    }
  },
  methods: {
    loadUserInfo() {
      UsersService.readProfileFromAPI(
          (resp) => {
            var response = DataUtils.parseDataToSingleObject(resp.data, Users);
            if (response == null) {
              this.$logger.error("Failed to receive user data!");
            } else {
              this.user = response;
            }
          }
      )
    },
    loadInfo() {
      let patchList = this.$store.state.auth.patches;
      if (patchList.updated) {
        this.loadUserInfo();
        this.patchList = patchList.data;
        clearInterval(this.checkInterval);
      }
    }
  },
  created() {
    /** @todo LIFT-546
     * Temporally is disabled
     */
    // this.checkInterval = setInterval(this.loadInfo, 2000);
  }
}
</script>

<style scoped>
.patch-core-icon {
  font-size: 200px;
}
.greeting {
  margin: auto;
}
</style>